@if (logoUrl) {
  <img [src]="logoUrl" alt="spotfight-logo" class="container row mx-auto p-3" style="max-width: 800px" />
}
<app-link-account-hint></app-link-account-hint>
<h2 class="mb-4">Deine Wertung</h2>
<app-user-rank
  [points]="$safeNavigationMigration(userScore?.points)"
  [rank]="$safeNavigationMigration(userScore?.rank)"
  >
</app-user-rank>
@if (longTermEvents.length > 0) {
  <div ngbAccordion class="long-term-events mb-5">
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <span class="long-term-summary">
            <span class="d-flex align-items-center gap-2">
              <span class="fw-semibold">Langzeit-Tipps</span>
              <span class="badge rounded-pill text-bg-secondary">{{ longTermEvents.length }}</span>
            </span>
            @if (openLongTermEvents.length > 0 || runningLongTermEvents.length > 0) {
              <span class="tip-status-summary">
                @if (openLongTermEvents.length > 0) {
                  <span class="badge rounded-pill text-bg-success">{{ openLongTermEvents.length }} offen</span>
                  @if (nextLongTermDeadline) {
                    <small class="text-muted">
                      Tippabgabe bis {{ nextLongTermDeadline | spotfightDateFormat }}
                    </small>
                  }
                }
                @if (runningLongTermEvents.length > 0) {
                  <span class="badge rounded-pill text-bg-warning">
                    <i class="bi bi-lock-fill me-1"></i>{{ runningLongTermEvents.length }}
                    {{ runningLongTermEvents.length === 1 ? 'Auswertung' : 'Auswertungen' }} ausstehend
                  </span>
                }
              </span>
            }
            @if (openLongTermEvents.length === 0 && runningLongTermEvents.length === 0) {
              <small class="text-muted">Keine offenen Tipps</small>
            }
          </span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            @for (event of longTermEvents; track event) {
              <app-compact-event-card
                [event]="event"
                class="d-block mb-3">
              </app-compact-event-card>
            }
          </ng-template>
        </div>
      </div>
    </div>
  </div>
}
<!-- Events Side by Side -->
<div class="row mb-5">
  <div class="col-md-6">
    <h2>Letzte Events</h2>
    @if (pastEvents?.length == 0) {
      <div>
        <div class="alert alert-info" role="alert">
          Keine vergangenen Events vorhanden
        </div>
      </div>
    }
    <app-event-accordion [events]="pastEvents"></app-event-accordion>
  </div>

  <div class="col-md-6">
    <h2 class="d-flex align-items-center gap-2">
      Nächste Events
      <a class="tippspiel-bell" href="https://www.spotfight.de/tippalarm/" target="_blank" aria-label="Tippspiel-Alarm">
        <i class="bi bi-bell" aria-hidden="true"></i>
      </a>
    </h2>
    @if (nextEvents?.length == 0) {
      <div>
        <div class="alert alert-info" role="alert">
          Keine kommenden Events vorhanden
        </div>
      </div>
    }
    <app-event-accordion [events]="nextEvents"></app-event-accordion>
  </div>
</div>
<app-score-table [scoreboard]="scoreboard"></app-score-table>
<div class="row">
  @if (this.scoreboard !== undefined && this.scoreboard.last_key !== null) {
    <button class="btn btn-primary my-2 mx-auto" (click)="loadMore()">Zeig mir mehr</button>
  }
</div>
